// These models are a typescript instantiation of the stringified definition in fc-datalayar/dataSchema.js.

export abstract class AnalyticsData {
    constructor(
        public readonly event: string,
        public title?: string,
        public description?: string,
        public type?: any,
        public properties?: any,
        public required?: string[],
        public errorMetric?: string,
        public errors?: any[]
    ) {}
}

export class AnalyticsDirectiveData {
    constructor(
        public on: string,
        public data: AnalyticsData
    ) {}
}

export class ClickAnalyticsData extends AnalyticsData {
    constructor(
        public clickedElement: string,
        public clickAction: string,
        public formName?: string,
        public clickUrl?: string,
        public impressionID?: string,
        public searchValue?: string,
        public analyticsEvents?: any[],
        title?: string,
        description?: string,
        type?: any,
        properties?: any,
        required?: string[],
        errorMetric?: string,
        errors?: any[],
        public formStepName?: string,
        public applicationVersion?: string
    ) {
        super('click', title, description, type, properties, required, errorMetric, errors);
    }
}

export class ErrorAnalyticsData extends AnalyticsData {
    constructor(
        public formName?: string,
        public errorType?: string,
        public errorDescription?: string,
        public errorMessage?: string,
        title?: string,
        description?: string,
        type?: any,
        properties?: any,
        required?: string[],
        errorMetric?: string,
        errors?: any[]
    ) {
        super('error', title, description, type, properties, required, errorMetric, errors);
    }
}

export class ImpressionAnalyticsData extends AnalyticsData {
    constructor(
        public impressionName: string,
        public impressionSource: string,
        public impressionID?: string,
        public impressionGroup?: string,
        public impressionIssue?: string,
        public impressionPath?: string,
        public impressionPosition?: string,
        public impressionCampaign?: string,
        public analyticsEvents?: any[],
        title?: string,
        description?: string,
        type?: any,
        properties?: any,
        required?: string[],
        errorMetric?: string,
        errors?: any[]
    ) {
        super('impression', title, description, type, properties, required, errorMetric, errors);
    }
}

export class PageviewAnalyticsData extends AnalyticsData {
    constructor(
        public pageDomain: string,
        public pageSiteSegment: string,
        public pageName: string,
        public userConsentStatus: string,
        public userLoginStatus: string,
        public platformEnvironment: string,
        public platformName: string,
        public pageType: string,
        public pageSiteSection?: string,
        public products?: Product[],
        public analyticsEvents?: any[],
        public caseId?: string,
        public userCustomerId?: string,
        public userAge?: number,
        public userAgeRange?: string,
        public customerProducts?: string[],
        public searchResults?: string,
        title?: string,
        description?: string,
        type?: any,
        properties?: any,
        required?: string[],
        errorMetric?: string,
        errors?: any[]
    ) {
        super('pageview', title, description, type, properties, required, errorMetric, errors);
    }
}

export class Product {
    constructor(
        public productName: string,
        public productCategory: string
    ) {}
}

export class ChatAnalyticsData extends AnalyticsData {
    constructor(
        public analyticsEvents: string[],
        title?: string,
        description?: string,
        type?: any,
        properties?: any,
        required?: string[],
        errorMetric?: string,
        errors?: any[]
    ) {
        super('chat', title, description, type, properties, required, errorMetric, errors);
    }
}

export class FormStepAnalyticsData extends AnalyticsData {
    constructor(
        public formName: string,
        public formType: string,
        public formStepName: string,
        public formStepNumber: number,
        public formStatus?: string,
        public formFieldValues?: FormFieldValue[],
        title?: string,
        description?: string,
        type?: any,
        properties?: any,
        required?: string[],
        errorMetric?: string,
        errors?: any[]
    ) {
        super('form step', title, description, type, properties, required, errorMetric, errors);
    }
}

export class PersistData extends AnalyticsData {
    constructor(
        public command: string,
        public data: any,
        public matchEvent: string,
        public duration?: number,
        public renew?: boolean
    ) {
        super('deq event command');
    }
}

export class DyncontentAnalyticsData extends AnalyticsData {
    constructor(
        public partName: string,
        public partAction: string,
        public partElement?: string
    ) {
        super('dyncontent');
    }
}

export class FormFieldValue {
    constructor(
        public name: string,
        public value: any,
        public anonymizeAs?: (value?: any, range?: any) => string
    ) {}
}

export interface Anonymizers {
    amount: (value: string, range?: number[]) => string;
    date: (value: Date) => string;
    birthDate: (value: Date) => string;
    zipCode: (value: string) => string;
    percentage: (value: number) => string;
    strip: (value?: any) => string;
}

export enum AuthenticationStatus {
    AUTHENTICATED = 'logged in',
    UNAUTHENTICATED = 'not logged in'
}
